// extracted by mini-css-extract-plugin
export default {"form":"MultiplePerson_form__kMFWa","addButton":"MultiplePerson_addButton__PNaTW","removeButton":"MultiplePerson_removeButton__tgPjs"};